(() => {
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const openButton = $('[data-menu-open]');
  const closeButton = $('[data-menu-close]');
  const drawer = $('[data-mobile-drawer]');
  const overlay = $('[data-menu-overlay]');

  const setMenu = (open) => {
    if (!drawer || !overlay || !openButton) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    openButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
    if (open) closeButton?.focus();
  };

  openButton?.addEventListener('click', () => setMenu(true));
  closeButton?.addEventListener('click', () => setMenu(false));
  overlay?.addEventListener('click', () => setMenu(false));

  const filterOpen = $('[data-filter-open]');
  const filterClose = $('[data-filter-close]');
  const filterDrawer = $('[data-filter-drawer]');
  const filterOverlay = $('[data-filter-overlay]');

  const setFilters = (open) => {
    if (!filterDrawer || !filterOverlay) return;
    filterDrawer.classList.toggle('is-open', open);
    filterOverlay.classList.toggle('is-open', open);
    document.body.classList.toggle('filter-open', open);
    if (open) filterClose?.focus();
  };

  filterOpen?.addEventListener('click', () => setFilters(true));
  filterClose?.addEventListener('click', () => setFilters(false));
  filterOverlay?.addEventListener('click', () => setFilters(false));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (drawer?.classList.contains('is-open')) setMenu(false);
    if (filterDrawer?.classList.contains('is-open')) setFilters(false);
  });

  $$('[data-auto-submit]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = $('[data-predictive-search-input]', this);
      this.results = $('[data-predictive-search-results]', this);
      this.endpoint = this.dataset.url || `${window.Shopify?.routes?.root || '/'}search/suggest`;
      this.abortController = null;
      this.timer = null;
      this.input?.addEventListener('input', () => this.queueSearch());
      this.input?.addEventListener('focus', () => {
        if (this.results?.innerHTML.trim()) this.open();
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    queueSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.search(), 250);
    }

    async search() {
      const term = this.input?.value.trim();
      if (!term || term.length < 2) {
        this.close();
        return;
      }

      this.abortController?.abort();
      this.abortController = new AbortController();

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection',
        'resources[limit]': '8',
        section_id: 'predictive-search'
      });

      try {
        const response = await fetch(`${this.endpoint}?${params.toString()}`, { signal: this.abortController.signal });
        if (!response.ok) throw new Error('Falha na busca');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = $('#shopify-section-predictive-search', doc);
        this.results.innerHTML = section?.innerHTML || '';
        this.results.innerHTML.trim() ? this.open() : this.close();
      } catch (error) {
        if (error.name !== 'AbortError') this.close();
      }
    }

    open() {
      if (!this.results) return;
      this.results.hidden = false;
    }

    close() {
      if (!this.results) return;
      this.results.hidden = true;
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  const toast = $('[data-cart-toast]');
  let toastTimer;
  const showToast = (message, isError = false) => {
    if (!toast) return;
    const text = $('[data-cart-toast-text]', toast);
    if (text) text.textContent = message;
    toast.style.borderColor = isError ? '#fecaca' : '';
    toast.style.background = isError ? '#fff1f2' : '';
    toast.style.color = isError ? '#9f1239' : '';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = $('button[type="submit"]', form);
    const original = button?.textContent || 'Adicionar ao carrinho';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adicionando…';
    }

    try {
      const id = Number($('[name="id"]', form)?.value);
      if (!id) throw new Error('Produto inválido');
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Não foi possível adicionar');
      const cartResponse = await fetch(`${root}cart.js`);
      const cart = await cartResponse.json();
      $$('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
      if (button) button.textContent = 'Adicionado ✓';
      showToast('Produto adicionado ao carrinho.');
    } catch (_) {
      if (button) button.textContent = 'Tente novamente';
      showToast('Não foi possível adicionar o produto.', true);
    } finally {
      setTimeout(() => {
        if (button) {
          button.textContent = original;
          button.disabled = false;
        }
      }, 1600);
    }
  });

  $$('[data-product-thumbnail]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const mainImage = $('.product-gallery__main-image');
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.srcset = '';
      mainImage.alt = thumbnail.dataset.imageAlt || '';
      $$('[data-product-thumbnail]').forEach((item) => item.classList.remove('is-active'));
      thumbnail.classList.add('is-active');
    });
  });

  const variantSelect = $('[data-variant-select]');
  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    const price = $('[data-product-price]');
    const compare = $('[data-product-compare-price]');
    const saving = $('[data-product-saving]');
    const mobilePrice = $('[data-mobile-product-price]');
    const currentRaw = Number(option.dataset.priceRaw || 0);
    const compareRaw = Number(option.dataset.comparePriceRaw || 0);

    if (price) price.textContent = option.dataset.price || '';
    if (mobilePrice) mobilePrice.textContent = option.dataset.price || '';

    if (compare && compareRaw > currentRaw) {
      compare.textContent = option.dataset.comparePrice || '';
      compare.hidden = false;
    } else if (compare) {
      compare.hidden = true;
    }

    if (saving && compareRaw > currentRaw) {
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' });
      saving.textContent = `Economize ${formatter.format((compareRaw - currentRaw) / 100)}`;
      saving.hidden = false;
    } else if (saving) {
      saving.hidden = true;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });

  const quantityInput = $('[data-quantity-input]');
  $('[data-quantity-minus]')?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
  });
  $('[data-quantity-plus]')?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
  });

  $('[data-scroll-to-product]')?.addEventListener('click', () => {
    $('.product-form')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => $('.product-form__submit')?.focus(), 450);
  });
})();
